// production Branch — hardcoded so CI/local .env.local cannot bake localhost into prod builds.
// For local API: use npm start with a temporary override only in development tooling, never via REACT_APP_* here.
export const API_BASE_URL = 'https://application.housingram.com/api';
export const USERMANAGEMENT_API_BASE_URL = 'https://application.housingram.com/api';
export const DOCGENERATION_API_BASE_URL = 'https://application.housingram.com/api';
export const APPLICATION_API_BASE_URL = 'https://application.housingram.com/api';
export const LIVEFEED_API_BASE_URL = 'https://application.housingram.com/api';
export const PINCODE_API_BASE_URL = 'https://api.postalpincode.in/pincode';
